(function () {
    if (window.zcComponentVideoBound) {
        return;
    }

    window.zcComponentVideoBound = true;

    document.addEventListener('click', function (event) {
        const deferredEmbedTrigger = event.target.closest('[data-zc-deferred-embed-trigger]');

        if (deferredEmbedTrigger) {
            const deferredEmbed = deferredEmbedTrigger.closest('[data-zc-deferred-embed]');

            if (deferredEmbed) {
                activateDeferredEmbed(deferredEmbed, true);
            }

            return;
        }

        const button = event.target.closest('.desktop-paused-button');

        if (!button) {
            return;
        }

        const video = document.getElementById('desktop-video-' + button.dataset.key);

        if (!video) {
            return;
        }

        if (video.paused) {
            const playPromise = video.play();
            button.classList.remove('video-paused');

            if (playPromise && typeof playPromise.catch === 'function') {
                playPromise.catch(function () {
                    button.classList.add('video-paused');
                });
            }
        } else {
            video.pause();
            button.classList.add('video-paused');
        }
    });

    let deferredEmbedObserver;

    function addAutoplay(iframe) {
        const source = iframe.getAttribute('src');

        if (!source || !/(youtube(?:-nocookie)?\.com|youtu\.be)/i.test(source)) {
            return;
        }

        try {
            const url = new URL(source, window.location.href);
            url.searchParams.set('autoplay', '1');
            iframe.setAttribute('src', url.toString());
        } catch (error) {
            const separator = source.indexOf('?') === -1 ? '?' : '&';
            iframe.setAttribute('src', source + separator + 'autoplay=1');
        }
    }

    function activateDeferredEmbed(container, shouldAutoplay) {
        if (!container || container.dataset.zcDeferredEmbedLoaded === 'true') {
            return;
        }

        const template = container.querySelector('[data-zc-deferred-embed-template]');

        if (!template) {
            return;
        }

        const content = template.content.cloneNode(true);
        const iframe = content.querySelector('iframe');
        const placeholder = container.querySelector('.zc-deferred-embed__placeholder');
        const trigger = placeholder && placeholder.querySelector('[data-zc-deferred-embed-trigger]');

        if (shouldAutoplay && iframe) {
            addAutoplay(iframe);
        }

        container.dataset.zcDeferredEmbedLoaded = 'true';
        container.classList.add('is-loading');
        container.setAttribute('aria-busy', 'true');

        if (trigger) {
            trigger.disabled = true;
        }

        const revealPlayer = function () {
            window.setTimeout(function () {
                window.requestAnimationFrame(function () {
                    container.classList.remove('is-loading');
                    container.classList.add('is-ready');
                    container.removeAttribute('aria-busy');
                });
            }, 150);
        };

        if (iframe) {
            iframe.addEventListener('load', revealPlayer, { once: true });
        }

        template.remove();
        container.appendChild(content);

        if (!iframe) {
            revealPlayer();
        }

        if (deferredEmbedObserver) {
            deferredEmbedObserver.unobserve(container);
        }
    }

    function observeDeferredEmbeds(root) {
        const embeds = root.querySelectorAll('[data-zc-deferred-embed]:not([data-zc-deferred-embed-observed])');

        if (!embeds.length) {
            return;
        }

        if (!('IntersectionObserver' in window)) {
            return;
        }

        if (!deferredEmbedObserver) {
            deferredEmbedObserver = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        activateDeferredEmbed(entry.target, false);
                    }
                });
            }, {
                rootMargin: '400px 0px',
                threshold: 0.01
            });
        }

        embeds.forEach(function (embed) {
            embed.dataset.zcDeferredEmbedObserved = 'true';
            deferredEmbedObserver.observe(embed);
        });
    }

    observeDeferredEmbeds(document);

    document.addEventListener('shopify:section:load', function (event) {
        observeDeferredEmbeds(event.target);
    });
})();
